export const isEnumValue = <T extends string>(enumValues: T[], value: string): value is T => {
  // eslint-disable-next-line no-type-assertion/no-type-assertion
  return enumValues.includes(value as T)
}
